import styleVariables from '../../../styles/common/_variables';
export const MODULE_ID = 'app';
export const META_COMPONENT_NAME = 'GCO';
export const SIGNALR_MODULE_ID = 'app-signalR';
export const SIGNALR_HUB_NAME = 'authenticatedHub';
export const SIGNALR_NOTIFICATION_RECEIVE_MSG = 'EventReceived';
export const TRANSLATIONS_LOCATIONS = [
    'components/Charts',
    'components/Form',
    'components/RelatedData',
    'modules/App',
    'modules/Account',
    'modules/AmbulatoryGlucoseProfile',
    'modules/ClinicManagement',
    'modules/CloudDrive',
    'modules/DataSources',
    'modules/Hcp',
    'modules/HcpExports',
    'modules/HcpStats',
    'modules/Layout',
    'modules/Mobile',
    'modules/MobileReports',
    'modules/Meter',
    'modules/Notifications',
    'modules/Patient',
    'modules/PatientResults',
    'modules/Visit'
];
export const CONTACT_EMAIL = 'support@glucocontro.online';
export const CLOUD_DRIVES = [
    'CentralStorage',
    'GoogleDrive'
];
export const CLOUD_DRIVES_LABELS = {
    CentralStorage: 'Central Storage',
    GoogleDrive: 'Google Drive'
};
export const PATIENT_DATABASES = {
    GlucoControDesktop: {
        label: 'GlucoContro Desktop',
        api: 'glucocontro',
        type: 'GCD'
    },
    GlucoFactsDelux: {
        label: 'Glucofacts™ Deluxe',
        api: 'glucofacts',
        type: 'GFD'
    },
    GlucoControOnline: {
        label: 'GlucoContro Online',
        type: 'GCO'
    }
};
export const WILDCARD_DEVICE_SERIAL_NUMBER_TOKENS = [
    'glucocontrodesktop'
];
export const PATIENTS_SOURCES = {
    ENROLL_CODE: 'EnrollCode',
    GLUCO_CONTRO_DESKTOP: 'GlucoControDesktop'
};
export const DATA_TYPES = [
    'BGM',
    'CGM'
]; // First is default
export const DIABETES_TYPES = [
    'NoResponse',
    'Type1',
    'Type2',
    'PreDiabetes',
    'GDM',
    'NotSure'
];
export const DIABETES_TYPES_HIDE_FOR_PWD = [];
export const DIABETES_TYPES_HIDE_FOR_HCP = [
    'NoResponse'
];
export const DIABETES_TYPES_HIDE_FOR_MALE = [
    'GDM'
];
export const TREATMENT_TYPES = [
    'NoResponse',
    'Insulin',
    'Oral',
    'Combination',
    'Lifestyle'
];
export const DATA_NOTE_TYPES = [
    // KPI
    'TotalReadings',
    'AvgReadings',
    'DaysWithoutReading',
    'GMI',
    'VeryHigh',
    'VeryLow',
    'StandardDeviation',
    'Average',
    'AveragePreMeal',
    'AveragePostMeal',
    'CV',
    // Trend Chart
    'Reading',
    'Mean',
    'MedianStd',
    'Hypoglycemia',
    'Hyperglycemia',
    'Count',
    // Glucose concentration level chart
    'GlucoseConcentrationLevelVeryHigh',
    'GlucoseConcentrationLevelHigh',
    'GlucoseConcentrationLevelTarget',
    'GlucoseConcentrationLevelLow',
    'GlucoseConcentrationLevelVeryLow'
];
export const GENERAL_NOTE_TYPES = [
    'Note',
    'Instruction',
    'PhysicalExamination',
    'Recommendation',
    'Comment'
];
export const NOTE_TYPES = [
    ...DATA_NOTE_TYPES,
    ...GENERAL_NOTE_TYPES
];
export const LANGUAGE_SELECTOR_DROPDOWN = `${MODULE_ID}/languageSelectorDropdown`;
export const MEASUREMENTS = {
    weight: {
        type: 'Weight',
        metric: 'weight'
    },
    height: {
        type: 'Height',
        metric: 'height'
    },
    lastWeight: {
        type: 'Weight',
        metric: 'weight'
    },
    lastHeight: {
        type: 'Height',
        metric: 'height'
    },
    systolicBloodPressure: {
        type: 'SystolicBloodPressure',
        metric: 'pressure'
    },
    diastolicBloodPressure: {
        type: 'DiastolicBloodPressure',
        metric: 'pressure'
    },
    randomBloodGlucoseLevel: {
        type: 'RandomBloodGlucoseLevel',
        metric: 'bloodGlucoseConcentration'
    },
    totalCholesterol: {
        type: 'TotalCholesterol',
        metric: 'cholesterol'
    },
    HDL: {
        type: 'HDL',
        metric: 'cholesterol'
    },
    LDL: {
        type: 'LDL',
        metric: 'cholesterol'
    },
    calcium: {
        type: 'Calcium',
        metric: 'calcium'
    },
    creatinine: {
        type: 'Creatinine',
        metric: 'creatinine'
    },
    HbA1C: {
        type: 'HbA1C',
        metric: 'HbA1C'
    },
    phosphorus: {
        type: 'Phosphorus',
        metric: 'phosphorus'
    },
    potassium: {
        type: 'Potassium',
        metric: 'potassium'
    },
    sodium: {
        type: 'Sodium',
        metric: 'sodium'
    },
    triglycerides: {
        type: 'Triglycerides',
        metric: 'triglycerides'
    },
    glomerularFiltrationRate: {
        type: 'GlomerularFiltrationRate',
        metric: 'filtration'
    },
    modificationOfDietInRenalDisease: {
        type: 'ModificationOfDietInRenalDisease',
        metric: 'filtration'
    }
};
/**
  Default precisions:
    toDisplay: 2
    toStorage: 3
 */ export const METRICS = {
    weight: {
        unit: 'KG',
        conversions: {
            LB: {
                factor: 2.2
            }
        }
    },
    height: {
        unit: 'CM',
        precisions: {
            toStorage: 1,
            toDisplay: 0
        },
        conversions: {
            IN: {
                factor: 0.3937,
                precisions: {
                    toStorage: 2,
                    toDisplay: 1
                }
            }
        }
    },
    pressure: {
        unit: 'MMHG'
    },
    bloodGlucoseConcentration: {
        unit: 'MG_DL',
        precisions: {
            toDisplay: 0
        },
        conversions: {
            MMOL_L: {
                factor: 0.0555,
                precisions: {
                    toDisplay: 1
                }
            }
        }
    },
    calcium: {
        unit: 'MG_DL',
        conversions: {
            MMOL_L: {
                factor: 0.25
            }
        }
    },
    cholesterol: {
        unit: 'MG_DL',
        conversions: {
            MMOL_L: {
                factor: 0.0259
            }
        }
    },
    creatinine: {
        unit: 'MG_DL',
        precisions: {
            toStorage: 4
        },
        conversions: {
            UMOL_L: {
                factor: 88.4,
                precisions: {
                    toStorage: 4
                }
            }
        }
    },
    phosphorus: {
        unit: 'MG_DL',
        conversions: {
            MMOL_L: {
                factor: 0.323
            }
        }
    },
    potassium: {
        unit: 'MG_DL',
        conversions: {
            MMOL_L: {
                factor: 0.26
            },
            MEQ_L: {
                factor: 0.26
            }
        }
    },
    sodium: {
        unit: 'MG_DL',
        conversions: {
            MMOL_L: {
                factor: 0.43
            },
            MEQ_L: {
                factor: 0.43
            }
        }
    },
    triglycerides: {
        unit: 'MG_DL',
        conversions: {
            MMOL_L: {
                factor: 0.0113
            }
        }
    },
    filtration: {
        unit: 'ML_MIN_1_73_M2'
    },
    CockcroftGaultFiltration: {
        unit: 'ML_MIN'
    },
    carbs: {
        unit: 'g',
        conversions: {
            KE: {
                factor: 0.1
            },
            BE: {
                factor: 0.0833
            },
            CC: {
                factor: 0.0667
            },
            CP: {
                factor: 0.1
            }
        }
    },
    HbA1C: {
        unit: 'PERCENT'
    }
};
/**
 * @deprecated Use conversion displayPrecision instead
 */ export const GLUCOSE_LEVELS_INPUTS_PRECISION = {
    MMOL_L: 1
};
export const METRICS_STANDARDS = {
    bloodGlucoseConcentration: {
        maxValue: 350,
        minValue: 10,
        preMeal: {
            highThreshold: 140,
            lowThreshold: 70
        },
        postMeal: {
            highThreshold: 180,
            lowThreshold: 70
        },
        critical: {
            highThreshold: 250,
            lowThreshold: 54
        }
    }
};
export const UNITS_SYMBOLS = {
    MG_DL: 'mg/dL',
    MEQ_L: 'mEq/L',
    MMOL_L: 'mmol/L',
    UMOL_L: '\u00b5mol/L',
    KG: 'kg',
    LB: 'lbs',
    CM: 'cm',
    IN: 'in',
    ML_MIN_1_73_M2: 'mL/min/1.73m\u00B2',
    ML_MIN: 'mL/min',
    MMHG: 'mmHg',
    PERCENT: '%',
    // carbs
    g: 'g',
    KE: 'KE',
    BE: 'BE',
    CC: 'CC',
    CP: 'CP'
};
export const BLOOD_GLUCOSE_CONCENTRATION_UNITS = {
    MG_DL: 'MG_DL',
    MMOL_L: 'MMOL_L'
};
export const FEATURE_TOGGLES = {
    featureCgm: 'featureCgm',
    featurePlatforms: 'featurePlatforms'
};
export const ANDROID_URLS = {
    us: 'https://play.google.com/store/apps/details?id=com.ascensia.contour.us',
    es: 'https://play.google.com/store/apps/details?id=com.ascensia.contour.es',
    sa: 'https://play.google.com/store/apps/details?id=com.ascensia.contour.sa',
    il: 'https://play.google.com/store/apps/details?id=com.ascensia.contour.il',
    pl: 'https://play.google.com/store/apps/details?id=com.ascensia.contour',
    it: 'https://play.google.com/store/apps/details?id=com.ascensia.contour.it',
    uk: 'https://play.google.com/store/apps/details?id=com.ascensia.contour.uk',
    ie: 'https://play.google.com/store/apps/details?id=com.ascensia.contour.ie',
    au: 'https://play.google.com/store/apps/details?id=com.ascensia.contour.au',
    si: 'https://play.google.com/store/apps/details?id=com.ascensia.contour.si'
};
export const IOS_URLS = {
    us: 'https://itunes.apple.com/us/app/contour-diabetes-app/id1173950283',
    es: 'https://itunes.apple.com/es/app/contour-diabetes-app/id1145662139',
    sa: 'https://itunes.apple.com/sa/app/contour-diabetes-app/id1249676767',
    il: 'https://itunes.apple.com/is/app/contour-diabetes-app/id1453869606',
    pl: 'https://itunes.apple.com/pl/app/contour-diabetes-app/id1069437241',
    it: 'https://itunes.apple.com/it/app/contour-diabetes-app/id1144642968',
    uk: 'https://itunes.apple.com/gb/app/contour-diabetes-app/id1144666843',
    ie: 'https://itunes.apple.com/ie/app/contour-diabetes-app/id1144658994',
    au: 'https://itunes.apple.com/au/app/contour-diabetes-app/id1320847361',
    si: 'https://itunes.apple.com/si/app/contour-diabetes-app/id1145666414'
};
export const GLUCOSE_LEVELS_COLORS = {
    veryHigh: styleVariables['brand-veryHigh'],
    high: styleVariables['brand-high'],
    target: styleVariables['brand-target'],
    tight: styleVariables['brand-tight'],
    low: styleVariables['brand-low'],
    veryLow: styleVariables['brand-veryLow']
};
export const CHART_ELEMENTS_COLORS = {
    line: '#C9CFDC',
    placeholder: '#E0E8F2'
};
export const NOT_DISCONNECTABLE_DATA_SOURCES = [
    'ContourCloud'
];
export const METRICS_UNITS_TYPE_NAMES = [
    'weight',
    'height',
    'pressure',
    'bloodGlucoseConcentration',
    'calcium',
    'cholesterol',
    'creatinine',
    'phosphorus',
    'potassium',
    'sodium',
    'triglycerides',
    'filtration',
    'CockcroftGaultFiltration',
    'HbA1C',
    'carbs'
];
export const FIELD_OPTION = {
    OPTIONAL: 'Optional',
    REQUIRED: 'Mandatory',
    HIDDEN: 'Hidden'
};
export const REQUIRED_REPORT_STATE_PATHS = [
    'ambulatoryGlucoseProfile',
    'app.regionName',
    'app.locale',
    'app.displayMode',
    'app.direction',
    'information.information',
    'layout.hideEmptyRows',
    'layout.showDayDividers',
    'account.metricsUnits',
    'account.activeClinicMembership',
    'account.activeClinicMembershipId',
    'account.hcpProfile.clinicHcpMemberships',
    'clinicManagement.clinicSettings',
    'patientResults.isTrendChartLineEnabled',
    'patientResults.imbPatterns',
    'patientResults.deviceMode',
    'patientResults.calculationFormula',
    'patientResults.reportTypes',
    'patientResults.gestationalReportSettings',
    'patientResults.reportsState.agpData',
    'patientResults.reportsState.accountPatientProfile',
    'patientResults.reportsState.phiSet.diabetesType',
    'patientResults.reportsState.phiSet.treatmentType',
    'patientResults.reportsState.phiSet.glucoseLevelTargets',
    'patientResults.reportsState.phiSet.customRanges',
    'patientResults.reportsState.phiSet.imports',
    'patientResults.reportsState.standards',
    'patientResults.reportsState.readings',
    'patientResults.reportsState.startDate',
    'patientResults.reportsState.endDate',
    'patientResults.reportsState.days',
    'patientResults.reportsState.daysWithReadings',
    'patientResults.reportsState.daysWithoutReadings',
    'patientResults.reportsState.relatedData',
    'patientResults.reportsState.preMeal',
    'patientResults.reportsState.postMeal',
    'patientResults.reportsState.data',
    'patientResults.reportsState.preMealReadings',
    'patientResults.reportsState.postMealReadings',
    'patientResults.reportsState.strictPostMealReadings',
    'patientResults.reportsState.strictPreMealReadings',
    'patientResults.reportsState.readingsWithoutFlag',
    'patientResults.reportsState.timeSeriesResources',
    'patientResults.reportsState.measurements',
    'patientResults.reportsState.start',
    'patientResults.reportsState.end'
];
export const CUSTOM_LOCALIZATION_SETTINGS_COOKIE = 'customLocalizationSettings';
export const DATE_FORMAT_TOKENS_REGEX = /\b(YYYY|MM|DD)\b/g;
export const SUPPORT_URL = 'https://support.glucocontro.online/hc/sections/360003715100-GlucoContro-Online-Guides';
export const MOBILE_SUPPORT_URL = 'https://support.glucocontro.online/hc/en-us/categories/8909045125148-CONTOUR-Diabetes-App-Guides';
